import React, { Component } from 'react';
import Rating from 'react-star-rating-component';
import $ from 'jquery';
import config from '../../API/DomainName';
import { USERURL, BASEURL } from '../../constant';

class FooterNew extends Component {
  constructor(props) {
    super(props);
    
  }
  componentDidMount() {
    
  }

  render() {
   
    return (
      <React.Fragment>
        <div className="row">
        
        </div>
      </React.Fragment>
    )
  }
}


export default FooterNew;





// WEBPACK FOOTER //
// ./src/components/LandingPages/FooterNew.jsx